import { useMediaQuery } from "@mui/material";
import LogoMain from "../../../../assets/images/logo.svg";
import CMSLogo from "../../../../assets/images/cms.png";
import LogoInverse from "../../../../assets/images/logo-inverse.svg";
import LogoMobile from "../../../../assets/images/logo-mobile.svg";
import { styled, useTheme } from "@mui/material/styles";
interface LogoProps {
  inverse?: boolean;
}

const StyledLogo = styled("img")({
  objectFit: "cover",
  rel: "preload",
});

const StyledButton = styled("button")({
  background: "none",
  border: "none",
  cursor: "pointer",
});
const Logo: React.FC<LogoProps> = ({ inverse, ...props }) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <span>
      <StyledButton aria-label="NCQA home page" title="NCQA home page">
        <StyledLogo src={lgUp ? (inverse ? LogoInverse : LogoMain) : LogoMobile} alt="NCQA's logo" />
      </StyledButton>
      <StyledButton aria-label="CMS home page" title="CMS home page">
        <StyledLogo src={lgUp ? CMSLogo : CMSLogo} alt="CMS' logo" style={{ marginBottom: lgUp ? "10px" : "revert" }} />
      </StyledButton>
    </span>
  );
};

export { Logo };
